import script from "./ModalAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAbout.vue?vue&type=script&setup=true&lang=js"

import "./ModalAbout.vue?vue&type=style&index=0&id=5702d256&lang=css"

const __exports__ = script;

export default __exports__